import $ from 'jquery'
import '@babel/polyfill'
import Foundation from './_foundation'
import 'motion-ui/dist/motion-ui'
import AOS from 'aos'
import throttle from 'lodash/throttle';
import '../../node_modules/jquery-parallax.js/parallax.min.js'
import { inlineSVG } from './_inline-svg'
import { lazyImages, lazyBackgrounds, lazyVideos, lazyOembeds, lazyInterchange, } from './_lazy-load'
import { smoothScrollOnPageLoad } from './_smoothScrollOnPageLoad';
import './_skip-link-focus-fix'
import './_acf-map'
import './_fixed-header'
// import './_header-height'
import './_hero-slider'
import './_notification'
import './_scroll-to-top'
import './_slick'
import './_off-canvas'
import './_faqs_accordion'
import './_defer-oembed'
// import './_fragmentURLs'

/* Additional Scripts */
// import { randomString } from './_random-string'
import './_ie'
import { equalHeights } from './_equal-heights'

// Foundation
$(document).foundation();

// Inline SVG
inlineSVG();

// Equal Heights
let $infocard_icon = $('.infocard__icon')
if ( $infocard_icon.length ) {
    setTimeout( () => {
        if ( 
            ! $('body').hasClass('is-mobile') 
            && ! $('body').hasClass('is-ie') 
            && ! $('body').hasClass('is-edge') 
        ) {
            equalHeights('.infocard__icon');
        }
    }, 1500 );
}

// KLUDGE: IE/Edge Video
jQuery( function( $ ) {
    setTimeout( function() {
        if ( 
            ( $('body').hasClass('is-edge') || $('body').hasClass('is-ie') ) 
            && ( $( '.hero-slider-container__video' ).length || $( '.slider-slide__video' ).length )
        ) {

            if ( $( '.hero-slider-container__video' ).length ) {
                
                $( '.hero-slider-container__video' ).get(0).play();
                $( '.hero-slider-container__video' ).css('opacity', 1);

            } else if ( $( '.slider-slide__video' ).length ) {

                for ( var i = 0; i <= $( '.slider-slide__video' ).length - 1; i++ ) {
                    
                    $( '.slider-slide__video' ).get(i).play();
                    $( '.slider-slide__video' ).css('opacity', 1);
                    
                }

            }
            
        }
    }, 2000 );
} );

// Smooth Scroll on page load
smoothScrollOnPageLoad();

// Lazy-load on DOMContentLoaded
window.addEventListener( 'DOMContentLoaded', function() {

    lazyImages();
    lazyBackgrounds();
    lazyVideos();
    lazyOembeds();
    lazyInterchange();

}, false);

// Lazy-load on scroll event
window.addEventListener( 'scroll', throttle( lazyImages, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyBackgrounds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyOembeds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyInterchange, 75 ), { passive: true } );

// AOS
AOS.init();

// Update placeholder text of GF Multi File Upload. Add class "js-update-placeholder" to the field to target.
jQuery(document).on('gform_post_render', function(){
    var $js_update_placeholder = $('.js-update-placeholder .gform_drop_instructions');

    $js_update_placeholder.html('Please attach a word or PDF version of your resume');

    $('.button.gform_button_select_files').attr('value', 'Browse');
});

// Add class to the body tag to prevent page scrolling when the off-canvas menu is open
let $offcanvas_toggle = $( '.off-canvas__toggle' );

$offcanvas_toggle.on( 'click', function( event ) {
    document.body.classList.toggle( 'prevent-vertical-scrolling' );
} );

// Safari HACK

var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if ( isSafari && ! $('body').hasClass('is-mobile') ) {
    document.body.classList.add('is-safari--desktop');
}

//
setTimeout( function() {
if ( $('.facetwp-page.first-page').length || $('.facetwp-page.last-page').length ) {
    let r = '<i class="fal fa-angle-right fa-2x"></i>';
    let l = '<i class="fal fa-angle-left fa-2x"></i>';
    
    
        $('.facetwp-page.first-page').html(l);
        $('.facetwp-page.last-page').html(r);
   
}
}, 2000 );


// Single - remove 
if ( $('body').hasClass('single-post') ) {
    var html = $('.single-entry__meta').html().trim();
    if ( html == '' ) {
        $('.single-entry__meta').remove();
    }
}


$('p:not(a),.title,.sms-solutionslist__title').not('p > a').each(function() {
    var $p = $(this).html().trim().replace(/SMS\|Host/gi,'<sup>SMS</sup>|Host');
    $(this).html($p);
}); 


$('p:not(a),.title,.sms-solutionslist__title').not('p > a').each(function() {
    var $p = $(this).html().trim().replace(/SpaSoft /gi,'Spa<em>Soft</em> ');
    $(this).html($p);
});











